import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": "通知公告反馈",
      "bordered": false,
      "size": "small",
      "bodyStyle": {
        padding: '1px'
      }
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _c('a-row', [_c('a-col', {
    class: _vm.$route.query.type == 1 ? 'card-left disabled-cursor' : 'card-left',
    attrs: {
      "span": 18
    }
  }, [_c('a-card', {
    class: _vm.$route.query.type == 1 ? 'disabled-events' : '',
    attrs: {
      "title": "通知公告内容",
      "bordered": false,
      "size": "small"
    }
  }, [_c('a-form-model', {
    attrs: {
      "model": _vm.formObject,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告分类",
      "prop": "cateName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.cateName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "cateName", $$v);
      },
      expression: "formObject.cateName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告标题",
      "prop": "title"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.title,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "title", $$v);
      },
      expression: "formObject.title"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "紧急状态",
      "prop": "emergency"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.emergency,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "emergency", $$v);
      },
      expression: "formObject.emergency"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("紧急")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("重要")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "是否置顶显示",
      "prop": "isTop"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.isTop,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isTop", $$v);
      },
      expression: "formObject.isTop"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "公告摘要",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "digest"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    style: {
      width: '97.5%'
    },
    attrs: {
      "placeholder": "请输入公告摘要",
      "max-length": 101,
      "rows": 2
    },
    model: {
      value: _vm.formObject.digest,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "digest", $$v);
      },
      expression: "formObject.digest"
    }
  })], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "公告排序",
      "prop": "sort"
    }
  }, [_c('a-input-number', {
    style: {
      width: '100%'
    },
    attrs: {
      "min": 1,
      "max": 9999,
      "placeholder": "请输入公告排序"
    },
    model: {
      value: _vm.formObject.sort,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "sort", $$v);
      },
      expression: "formObject.sort"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organAndPost"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    model: {
      value: _vm.formObject.organAndPost,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organAndPost", $$v);
      },
      expression: "formObject.organAndPost"
    }
  })], 1)], 1)], 1), _vm.isDirector ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需财务总监审核",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    attrs: {
      "disabled": _vm.$route.query.type == 2
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.isDirectorJWB ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    style: {
      width: '100%'
    },
    attrs: {
      "label": "是否需要加签",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-radio-group', {
    staticStyle: {
      "padding-left": "15px"
    },
    attrs: {
      "disabled": _vm.$route.query.type == 2
    },
    model: {
      value: _vm.formObject.isAppend,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "isAppend", $$v);
      },
      expression: "formObject.isAppend"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1) : _vm._e(), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "发布范围",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "range"
    }
  }, [_c('a-radio-group', {
    model: {
      value: _vm.formObject.range,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "range", $$v);
      },
      expression: "formObject.range"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("全校教职工")]), _c('a-radio', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("当前组织层级")]), _c('a-radio', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("当前组织层级指定人员")]), _c('a-radio', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("自定义")]), _vm.formObject.range === 1 || _vm.formObject.range === 3 ? _c('div', {
    staticStyle: {
      "height": "15px"
    }
  }) : _vm._e(), _vm.formObject.range === 1 ? _c('select-person', {
    ref: "selectPerson",
    attrs: {
      "width": "97.5%",
      "height": "150px"
    },
    model: {
      value: _vm.formObject.customize,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "customize", $$v);
      },
      expression: "formObject.customize"
    }
  }) : _vm._e(), _vm.formObject.range === 3 ? _c('a-select', {
    style: {
      width: '595px'
    },
    attrs: {
      "allowClear": "",
      "show-search": "",
      "mode": "multiple",
      "placeholder": "请选择指定人员",
      "option-filter-prop": "children"
    },
    model: {
      value: _vm.optionVal,
      callback: function callback($$v) {
        _vm.optionVal = $$v;
      },
      expression: "optionVal"
    }
  }, _vm._l(_vm.optionData, function (item) {
    return _c('a-select-option', {
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1) : _vm._e()], 1)], 1)], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticClass: "form-wangedit",
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "公告内容",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      },
      "prop": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "margin-top": "10px",
      "width": "97.5%"
    }
  }, [_c('Toolbar', {
    staticStyle: {
      "border-bottom": "1px solid #ccc"
    },
    attrs: {
      "editor": _vm.editor,
      "defaultConfig": _vm.toolbarConfig,
      "mode": _vm.mode
    }
  }), _c('Editor', {
    staticStyle: {
      "height": "400px",
      "overflow-y": "hidden"
    },
    attrs: {
      "defaultConfig": _vm.editorConfig,
      "mode": _vm.mode
    },
    on: {
      "onCreated": _vm.onCreated
    },
    model: {
      value: _vm.formObject.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "content", $$v);
      },
      expression: "formObject.content"
    }
  })], 1)])], 1)], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px",
      "pointer-events": "auto"
    },
    attrs: {
      "label": "文件",
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-list', {
    style: {
      width: '97.5%'
    },
    attrs: {
      "data-source": _vm.formObject.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filePath),
            "download": item.fileName
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.fileName) + " ")])]), _c('div', [_vm._v(_vm._s(item.createTime))])], 1);
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-card', {
    staticClass: "card-rigth",
    attrs: {
      "title": _vm.feedTitle,
      "bordered": false,
      "size": "small"
    }
  }, [_c('a-form-model', {
    ref: "feedForm",
    attrs: {
      "model": _vm.formObjFeed,
      "rules": _vm.rules,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 17
      },
      "hideRequiredMark": true
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "反馈用户",
      "prop": "feekName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "disabled": true
    },
    model: {
      value: _vm.formObjFeed.userName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObjFeed, "userName", $$v);
      },
      expression: "formObjFeed.userName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId"
    }
  }, [_vm.$route.query.type == 1 && (_vm.$route.query.status == null || _vm.$route.query.status == 4) ? _c('a-cascader', {
    style: {
      width: '100%'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      },
      "placeholder": "请选择所属组织及岗位"
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObjFeed.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.formObjFeed, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObjFeed.organPostId"
    }
  }) : _c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请选择所属组织及岗位",
      "disabled": true
    },
    model: {
      value: _vm.formObjFeed.organAndPost,
      callback: function callback($$v) {
        _vm.$set(_vm.formObjFeed, "organAndPost", $$v);
      },
      expression: "formObjFeed.organAndPost"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "反馈内容",
      "prop": "content"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入反馈内容",
      "rows": 15,
      "max-length": 501
    },
    model: {
      value: _vm.formObjFeed.content,
      callback: function callback($$v) {
        _vm.$set(_vm.formObjFeed, "content", $$v);
      },
      expression: "formObjFeed.content"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "附件"
    }
  }, [_vm.$route.query.type == 1 && (_vm.$route.query.status == null || _vm.$route.query.status == 4) ? _c('a-upload-dragger', {
    staticClass: "common-upload",
    attrs: {
      "name": "file",
      "accept": ".pdf,.doc,.docx,.jpg,.jpge,",
      "multiple": true,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "fileList": _vm.fileObj,
      "remove": _vm.delFile
    },
    model: {
      value: _vm.fileObj,
      callback: function callback($$v) {
        _vm.fileObj = $$v;
      },
      expression: "fileObj"
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])]) : _c('div', {
    staticClass: "file-item"
  }, [_c('a-list', {
    style: {
      width: '97.5%'
    },
    attrs: {
      "data-source": _vm.formObjFeed.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filepath),
            "download": item.filename
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.filename) + " ")])])], 1);
      }
    }])
  })], 1)], 1), _c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "wrapper-col": {
        span: 17,
        offset: 7
      }
    }
  }, [_vm.$route.query.type == 1 ? _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交")])], 1) : _vm._e()])], 1)], 1)], 1)], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };